import React, { useState, useEffect } from 'react';
import './App.css';
import { ApiResponse } from './types';
import LoadingModal from './LoadingModal';

function SessionGenerator() {
  const [scenarioId, setScenarioId] = useState<string>('');
  const [fiveDigitCode, setFiveDigitCode] = useState<string>('');
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>('');


  
  // Check for query string parameter on component mount
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const scenarioIdFromQuery = urlParams.get('scenario_id');

    if (scenarioIdFromQuery) {
      // Clear the URL by replacing current state
      window.history.replaceState({}, document.title, window.location.pathname);

      // Automatically submit the scenario ID from query string
      submitScenarioId(scenarioIdFromQuery);
    }
  }, []);

  const submitScenarioId = async (id: string) => {
    if (!id.trim()) {
      setError('Please enter a valid scenario ID');
      return;
    }

    setLoading(true);
    setError('');
    setFiveDigitCode('');

    try {
      const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
      
      if (!apiEndpoint) {
        throw new Error('API endpoint not configured');
      }

      const response = await fetch(apiEndpoint, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({action: "create_session", scenario_id: id }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data: ApiResponse = await response.json();
      console.log('API Response:', data);
      if (typeof data.access_code === 'string') {

        setFiveDigitCode(data.access_code);
      } else {
        setError(data.message || 'Failed to generate code');
      }
    } catch (err) {
      setError(err instanceof Error ? err.message : 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    submitScenarioId(scenarioId);
  };

  return (
    <>
      <div className="App">
        <div className="container">
          <h1>Session ID to 5-Digit Code Generator</h1>
          {!fiveDigitCode && (
          <form onSubmit={handleSubmit} className="session-form">
            <div className="input-group">
              <label htmlFor="scenarioID">Enter Scenario ID:</label>
              <input
                type="text"
                id="scenarioID"
                value={scenarioId}
                onChange={(e) => setScenarioId(e.target.value)}
                placeholder="Enter your scenario ID"
                disabled={loading}
              />
            </div>
            

            <button type="submit" disabled={loading || !scenarioId.trim()}>
              {loading ? 'Generating...' : 'Generate 5-Digit Code'}
            </button>
          </form>
          )}

          {error && (
            <div className="error-message">
              <p>Error: {error}</p>
            </div>
          )}

          {fiveDigitCode && (
            <div className="result">
              <h2>Your 5-Digit Code:</h2>
              <div className="code-display">{fiveDigitCode}</div>
            </div>
          )}

          {!fiveDigitCode && (
            <>
              <div className="instructions">
                <h3>How to use:</h3>
                <ul>
                  <li>Enter a Scenario ID in the input field and click "Generate 5-Digit Code"</li>
                  <li>Or visit this page with a query parameter: <code>?scenario_id=your-scenario-id</code></li>
                </ul>
              </div>

              <div style={{ marginTop: '2rem', textAlign: 'center' }}>
                <a href="/generate-qr" style={{ color: '#007bff', textDecoration: 'none' }}>
                  Generate QR Code →
                </a>
              </div>
            </>
          )}
        </div>
      </div>
      
      <LoadingModal 
        isVisible={loading} 
        message="Generating your 5-digit code..." 
      />
    </>
  );
}

export default SessionGenerator;